<form #form="ngForm">
    <h3 class="ui header">{{ 'time-off-v3.assignedEmployees' | translate }}</h3>

    <div class="margin-top margin-bottom" *ngIf="assignedEmployees.length === 0">
        {{ 'time-off-v3.noEmployeesAssignedToPolicy' | translate }}
    </div>

    <div class="scrollable margin-top margin-bottom ui list" *ngIf="assignedEmployees.length > 0">
        <ng-container *ngFor="let employee of assignedEmployees">
            <div class="item flex">
                <app-avatar [employee]="employee" [name]="true"></app-avatar>
                <ui-badge *ngIf="employee?.scheduledForFuturePolicyAssignment">{{
                    'time-off-v3.scheduled' | translate
                }}</ui-badge>
            </div>
        </ng-container>
    </div>

    <app-common-bulk-select-employee-dialog #employeeSelect [label]="'Assign'"></app-common-bulk-select-employee-dialog>
    <ui-button class="margin-top" type="primary" (click)="onEdit()">{{
        'time-off-v3.selectEmployees' | translate
    }}</ui-button>
</form>
